<template>
    <div>
        <div class="nav-item d-md-none">
            <a class="nav-link pl-0 pr-0 d-block pb-0 caption text-bold text-secondary text-right" id="filters-toggler" @click="toggleFilters">
                <span v-if="filterIsVisibleMobile">{{trans('community.show_options')}}</span>
                <span v-else>{{trans('community.hide_options')}}</span>
            </a>
        </div>

        <div class="row justify-content-center my-4 pb-5">
            <div class="col-12 col-md-4" :class="filterIsVisibleMobile ? 'isHiddenMobile' : 'isVisibleMobile'">
                <community-posts-filters
                    @getPosts="getPosts"
                    :orderBy="this.$route.query.orderBy ? this.$route.query.orderBy : this.orderBy"
                />
            </div>
            <div class="col-12 col-md-8">
                <community-posts-content
                    :posts=posts
                    :isLoading=isLoading
                    :currentPage=currentPage
                    :lastPage=lastPage
                    @loadMorePosts="loadMorePosts"
                />
            </div>
        </div>

        <b-modal
            id="create-post-modal"
            header-class="no-border"
            centered
            hide-footer
            ref="create-post-modal"
        >
            <template v-slot:modal-header="{ close }">
                <p class="text-primary text-bold">{{trans('community.add_your_post')}}</p>
                <b-icon icon="x" v-on:click="close()" scale="2" class="close-button" variant="primary"></b-icon>
            </template>
            <div class="row">
                <div class="col-12">
                    <create-post-form
                        @onPostCreate="onPostCreate"
                    />
                </div>
            </div>
        </b-modal>
    </div>

</template>

<script>
    import CommunityPostsContent from './CommunityPostsContent'
    import CommunityPostsFilters from './CommunityPostsFilters'
    import CreatePostForm from './CreatePostForm'


    export default {
        name: "CommunityPosts",
        components: { CommunityPostsContent, CommunityPostsFilters, CreatePostForm },

        data() {
          return {
              isLoading: true,
              currentPage: 1,
              lastPage: 10,
              posts: [],
              orderBy: '5',
              filterIsVisibleMobile: true
          }
        },

        methods: {
            getPosts(page, search, isFiltering, audience, orderBy, postId){
                this.$axios.get('/api/rest/community/post', {params : {page: page, search: search, audience: audience, orderBy: orderBy, postId: postId}})
                    .then((response) => {
                        if (isFiltering) {
                            this.posts = [];
                        }
                        this.posts = this.posts.concat(response.data.data)
                        this.currentPage = response.data.current_page
                        this.lastPage = response.data.last_page
                        this.isLoading = false

                        })
                        .catch((e)=>{
                            console.log(e);
                        })
            },
            onPostCreate(postData) {
                this.$axios.post('/api/rest/community/post', postData)
                    .then((res)=>{
                        this.$refs['create-post-modal'].hide()
                        this.fetchPosts();
                        this.$router.push({ path: 'community', query: { search: '', audience: this.$route.query.audience, orderBy: this.orderBy } }).catch(() => {});
                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            },
            loadMorePosts(){
                this.getPosts(this.currentPage + 1, this.$route.query.search)
            },
            toggleFilters() {
                this.filterIsVisibleMobile = !this.filterIsVisibleMobile;
            },
            fetchPosts(){
                this.getPosts(
                    this.currentPage,
                    this.$route.query.search,
                    true,
                    this.$route.query.audience,
                    this.$route.query.orderBy ? this.$route.query.orderBy : this.orderBy,
                    this.$route.query.postId ? this.$route.query.postId : ''
                );
            }
        },
        mounted() {
            this.fetchPosts();
        }
    }
</script>

<style scoped lang="scss">
    @media (max-width: 768px) {
        .isHiddenMobile {
            display: none;
        }
        .isVisibleMobile {
            display: block;
        }
    }
</style>
